/* eslint-disable */
import React, { useContext, useEffect, useRef } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import AppContext from 'context/Context';
import classNames from 'classnames';
import NavbarTop from 'components/navbar/top/NavbarTop';
import NavbarVertical from 'components/navbar/vertical/NavbarVertical';
import Footer from 'components/footer/Footer';
import ProductProvider from 'components/app/e-commerce/ProductProvider';
import CourseProvider from 'components/app/e-learning/CourseProvider';
import CallPath from 'components/tab-content/CallPath';
import AppProvider, { AuthContext } from 'context/AppContext';
import FooterStandard from 'components/pages/landing/FooterStandard';
import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';
import CookieConsent, { Cookies } from "react-cookie-consent";
import SupportCanvas from 'components/support-canvas/supportcanvas'
import SettingsToggle from 'components/settings-panel/SettingsToggle';

const MainLayout = () => {
  const { hash, pathname } = useLocation();
  const isKanban = pathname.includes('kanban');
  const { config: { isFluid, navbarPosition } } = useContext(AppContext);
  const { divT_Id, catchMouseMove } = useContext(AuthContext);
  const getMouseUpEvent = useRef(null);
  const getMouseDownEvent = useRef(null);

  useEffect(() => {}, [divT_Id]);

  useEffect(() => {
    setTimeout(() => {
      if (hash) {
        const id = hash.replace('#', '');
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }
      }
    }, 0);
  }, [hash]);

  useEffect(() => {
    const handleMouseUp = (e) => {
      catchMouseMove.current = false;
      getMouseUpEvent.current = e.target.id;
      document.body.style.cursor = 'default';
    };
    const handleMouseDown = (e) => {
      getMouseDownEvent.current = e.target.id;
    };

    document.addEventListener('mousedown', handleMouseDown);
    document.addEventListener('mouseup', handleMouseUp);

    return () => {
      document.removeEventListener('mousedown', handleMouseDown);
      document.removeEventListener('mouseup', handleMouseUp);
    };
  }, []);

  // Eğer register path ise Outlet render et
  if (pathname === '/authentication/split/register') {
    return <Outlet />;
  }

  return (
    <div className={isFluid ? 'container-fluid' : 'container'}>
      {(navbarPosition === 'vertical' || navbarPosition === 'combo') && (
        <NavbarVertical />
      )}
      <AppProvider>
        <ProductProvider>
          <CourseProvider>
            <div className={classNames('content', { 'pb-0': isKanban })}>
              <NavbarTop />
              <BrowserView>
                <CallPath />
                <CookieConsent
                  enableDeclineButton
                  location="bottom"
                  buttonText="Accept"
                  cookieName="myAwesomeCookieName2"
                  style={{ background: "#3498DA" }}
                  buttonStyle={{ color: "black", fontSize: "13px", background: 'rgb(255,212,45)', borderRadius: 8 }}
                  declineButtonText='Reject All'
                  declineButtonStyle={{ color: "black", fontSize: "13px", background: 'white', borderRadius: 8 }}
                  expires={150}
                  flipButtons='true'
                >
                  This website uses cookies to enhance user experience and to analyze performance and traffic on our website. We also share information about your use of our site with our social media, advertising, and analytics partners. Learn more about who we are, how you can contact us, and how we process personal data in our Privacy Policy.
                </CookieConsent>
              </BrowserView>
              <MobileView>
                <Outlet />
                <CookieConsent
                  enableDeclineButton
                  location="bottom"
                  buttonText="Accept"
                  cookieName="myAwesomeCookieName2"
                  style={{ background: "#3498DA" }}
                  buttonStyle={{ color: "black", fontSize: "13px", background: 'rgb(255,212,45)', borderRadius: 8 }}
                  declineButtonText='Reject All'
                  declineButtonStyle={{ color: "black", fontSize: "13px", background: 'white', borderRadius: 8 }}
                  expires={150}
                  flipButtons='true'
                >
                  This website uses cookies to enhance user experience and to analyze performance and traffic on our website. We also share information about your use of our site with our social media, advertising, and analytics partners. Learn more about who we are, how you can contact us, and how we process personal data in our Privacy Policy.
                </CookieConsent>
              </MobileView>
            </div>
          </CourseProvider>
        </ProductProvider>
      </AppProvider>
    </div>
  );
};

export default MainLayout;
